var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row mb-2" }, [
    _c(
      "div",
      { staticClass: "col-3" },
      [
        _c("el-input", {
          attrs: { placeholder: "Zeilen Beschreibung" },
          model: {
            value: _vm.text.name,
            callback: function($$v) {
              _vm.$set(_vm.text, "name", $$v)
            },
            expression: "text.name"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-3" },
      [
        _c("el-input", {
          attrs: { placeholder: "Text Preis 1" },
          model: {
            value: _vm.text.price1,
            callback: function($$v) {
              _vm.$set(_vm.text, "price1", $$v)
            },
            expression: "text.price1"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _vm.priceCols == 2 || _vm.priceCols == 3
      ? _c(
          "div",
          { staticClass: "col-3" },
          [
            _c("el-input", {
              attrs: { placeholder: "Text Preis 2" },
              model: {
                value: _vm.text.price2,
                callback: function($$v) {
                  _vm.$set(_vm.text, "price2", $$v)
                },
                expression: "text.price2"
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.priceCols == 3
      ? _c(
          "div",
          { staticClass: "col-3" },
          [
            _c("el-input", {
              attrs: { placeholder: "Text Preis 3" },
              model: {
                value: _vm.text.price3,
                callback: function($$v) {
                  _vm.$set(_vm.text, "price3", $$v)
                },
                expression: "text.price3"
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }